import Vue from 'vue'
// import store from '../store'
import {i18n} from '@/i18n'
import './date'
import {NO_IMAGE} from '@/utils/global'
import { filterList } from './const'
import { AuthTypeList } from '../constants'
// import * as types from './filter-types'
// const prod = process.env.NODE_ENV === 'production'
Vue.filter('currencyAbbr', (value) => {
  switch (value) {
    case 1:
      return 'RMB'
    case 2:
      return 'USD'
  }
})
Vue.filter('couponCurrencyAbbr', (value) => {
  switch (value) {
    case 1:
      return 'CRMB'
    case 2:
      return 'CUSD'
  }
})
Vue.filter('nodePriceUnit', (value) => {
  return {
    1: 'RMB/node/h',
    2: 'USD/node/h',
  }[value]
})

Vue.filter('corePriceUnit', (value) => {
  return {
    1: 'RMB/thread/h',
    2: 'USD/thread/h',
  }[value]
})

Vue.filter('fileSize', (value) => {
  const toFixed = val => val.toFixed(2)

  if (value < 1024) {
    return `${value}B`
  } else if (value < 1048576) {
    return `${toFixed(value / 1024)}K`
  } else if (value < 1073741824) {
    return `${toFixed(value / 1048576)}M`
  } else if (value < 1099511627776) {
    return `${toFixed(value / 1073741824)}G`
  } else if (value < 1125899906842624) {
    return `${toFixed(value / 1099511627776)}T`
  }
})

Vue.filter('imgFix', value => {
  if (!value) return NO_IMAGE
  // if (prod) return value
  return value
})

Vue.filter('judgment', value => {
  return !+value ? i18n.t('common_no') : i18n.t('common_yes')
})
// 转化url，报错返回原数据
Vue.filter('decodeURIComponentWithoutError', data => {
  try {
    return decodeURIComponent(data)
  } catch (err) {
    console.error(err)
    return data
  }
})

Vue.filter('platformList', value => {
  if (value instanceof Array) {
    return value.map(item => i18n.t(`common_platform_${item}`)).toString()
  }
  return ''
})

Vue.filter('authTypeList', value => {
  if (value <= AuthTypeList.EnterpriseAuthFail) {
    return i18n.t(`common_authTypeList_${value}`)
  } else if (value === AuthTypeList.PersonaChangeFailed || value === AuthTypeList.PersonalToEnterpriseFailed) {
    return i18n.t(`common_authTypeList_6`)
  } else if (value === AuthTypeList.EnterpriseChangeFailed) {
    return i18n.t(`common_authTypeList_7`)
  } else if (value === AuthTypeList.PersonalChanging) {
    return i18n.t(`common_authTypeList_5`)
  }
})

filterList.map(field => {
  Vue.filter(field, value => {
    if (parseInt(value) > -1) {
      return i18n.t(`common_${field}_${value}`)
    }
    return ''
  })
})

Vue.filter('nullToBar', value => value === null ? '-' : value)
